import { Plus } from 'lucide-react';
import React from 'react';

interface AddButtonProps {
  onClick?: () => void;
  size?: 'sm' | 'lg';
  className?: string;
}

export const AddButton: React.FC<AddButtonProps> = ({ 
  onClick, 
  size = 'lg',
  className = ''
}) => {
  const isSmall = size === 'sm';

  return (
    <button 
      aria-label="Add Shout"
      onClick={onClick}
      className={`
        bg-brand-red text-white shadow-xl flex items-center justify-center 
        hover:bg-brand-red-hover transition active:scale-95 border-white/20 
        inline-flex align-middle
        ${isSmall ? 'rounded-full p-1 border' : 'rounded-full w-12 h-12 border-2'}
        ${className}
      `}
    >
      <Plus 
        size={isSmall ? 14 : 24} 
        strokeWidth={3} 
      />
    </button>
  );
};
